export default function authHeader() {
  let token = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).token : null
  if (token) {
    return { "Authorization": 'Bearer ' + token };
  } else {
    return {};
  }
}
